/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name inputautocomplete
 * @description JqueryUI Autocomplete Wrapper for AngularJS
 * @attr {String} autocomplete-label The field that is bound to the label field
 * @attr {Object} autocomplete-items An expression that returns an array of promise of items
 * @attr {Function} autocomplete-select On select callback.
 * @attr {String} autocomplete-categoryfield Field of the item that is used to group the items by
 * @attr {Function} autocomplete-matchfunction Function used within the $filter to determine if an item matches
 * @attr {String} autocomplete-labelfield Name of the field from the selected objetc to use as the label
 * @attr {Number} autocomplete-minlength Minimum characters required for search to take place
 * @attr {String} autocomplete-valuefield Name of the field from the selected object to use as the value
 * @attr {String} autocomplete-categoryfield Name of the field from each object to use as the category
 * @attr {Function} autocomplete-renderline Callback function which returns HTML to use for each line
 * @attr {Function} autocomplete-renderheader Callback function which returns HTML to use at the top
 * @attr {Function} autocomplete-more Callback function for when 'More' is clicked. If undefined, More is hidden
 */
angular.module('mercury.directives.inputautocomplete', [])
.directive('inputautocomplete', ["$parse", "$filter", "$q", "$timeout", "$compile", function($parse, $filter, $q, $timeout, $compile) {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: true,
    link: function(scope, element, attrs, ngModelCtrl) {
      var _opt = {};

      var defaultMatchFunction = function(choice) {
        var input = element.val();
        if (input === '') {
          return true;
        } else {
          var tokens = input.split(' ');
          var match = true;
          var label = $parse(_opt.labelField)(choice);

          for (var token in tokens) {
            if (token !== '' && typeof label == 'string' && label.toLowerCase().indexOf(tokens[token].toLowerCase()) === -1) {
              match = false;
              break;
            }
          }
          return match;
        }
      };

      _opt = {
        callbackDelay: (attrs.autocompleteCallbackdelay) ? parseInt(attrs.autocompleteCallbackdelay, 10) : 100,
        matches: 10,
        minLength: (attrs.autocompleteMinlength) ? parseInt(attrs.autocompleteMinlength, 10) : 0,
        labelField: (attrs.autocompleteLabelfield) ? attrs.autocompleteLabelfield : 'name',
        valueField: (attrs.autocompleteValuefield) ? attrs.autocompleteValuefield : 'id',
        matchFunction: (attrs.autocompleteMatchfunction) ? $parse(attrs.autocompleteMatchfunction)(scope) : defaultMatchFunction,
        categoryField: attrs.autocompleteCategoryfield,
        moreFunction: (attrs.autocompleteMore) ? attrs.autocompleteMore : null,
        renderLineFunction: attrs.autocompleteRenderline ? $parse(attrs.autocompleteRenderline)(scope) : function(item) {
          return item.label;
        },
        renderHeaderFunction: attrs.autocompleteRenderheader ? $parse(attrs.autocompleteRenderheader)(scope) : null
      };

      ngModelCtrl.$options = {
        updateOn: 'blur'
      };

      ngModelCtrl.$parsers.unshift(function() {
        //Returning an undefined value is the parser breaks the required validation.
        //Return null in that case.
        var modelValue = $parse(attrs.ngModel)(scope);
        return angular.isDefined(modelValue) ? modelValue : null;
      });

      ngModelCtrl.$validators.required = function(modelValue) {
        var valid = element.hasClass('nullable') || (modelValue !== null && typeof modelValue != 'undefined');
        return valid;
      };

      var render = function() {
        if (attrs.autocompleteLabel) {
          var label = $parse(attrs.autocompleteLabel)(scope);
          if (label || label === '') {
            ngModelCtrl.$viewValue = label;
          }
        } else {
          ngModelCtrl.$viewValue = '';
        }
        ngModelCtrl.$render();
        ngModelCtrl.$validate();
      };

      if (attrs.autocompleteLabel) {
        scope.$watch(attrs.autocompleteLabel, function() {
          render();
        });
      }

      render();

      var extractLabelValue = function(match) {
        var result = {
          label: $parse(_opt.labelField)(match),
          value: match
        };

        if (_opt.categoryField) {
          result.category = $parse(_opt.categoryField)(match);
        }
        return result;
      };

      var loader = null;
      var requestsPending = 0;

      var showLoader = function() {
        requestsPending++;
        if (loader === null) {
          loader = angular.element('<i class="fa fa-spinner fa-spin" style="margin-left: -20px;"></i>');
          element.after(loader);
        }
      };

      var hideLoader = function() {
        requestsPending--;
        if (requestsPending === 0) {
          loader.remove();
          loader = null;
        }
      };

      /**
      * Base level function for the "More" link. Calls the controller function, then closes the autocomplete
      */
      scope.moreLinkClicked = function() {
        $timeout(function() {
          scope.$eval(_opt.moreFunction);
        }, 100);

        //Close the autocomplete.
        $timeout(function() {
          element.blur();
        });
      };

      $(element).focus(function() {
        $.widget('custom.autocomplete', $.ui.autocomplete, {
          _create: function() {
            this._super();
            this.widget().menu('option', 'items', '> :not(.ui-autocomplete-category)');
          },
          _renderMenu: function(ul, items) {
            //The only option was a placeholde result. The actual options should be empty
            if (items.length == 1 && items[0].label == '_EMPTYRESULT_' && items[0].value == '_EMPTYRESULT_') {
              items = [];
            }

            var _this = this;

            if (attrs.autocompleteOrderBy) {
              items = $filter('orderBy')(items, attrs.autocompleteOrderBy);
            } else {
              // This is _probably_ wrong for your use case, but it's been
              // here for 9 years so we won't mess with the default behaviour.
              // If your autocomplete isn't ordered how you want, use the
              // autocomplete-order-by="<object property name to order by>"
              // directive to fix it.
              items = $filter('orderBy')(items, _opt.labelField + '.length');
            }

            //take the first 10 matches.
            items = items.slice(0, _opt.matches);

            // If we have defined a category. The orderBy above might have seperated some items from the same group.
            // Items on the same category need to be grouped together inorder for the list to be displayed correctly
            if (_opt.categoryField) {
              var groupedByCategory = {};

              //Loop through each match, grouping them by category.
              angular.forEach(items, function(item) {
                var itemCategory = $parse(_opt.categoryField)(item);

                if (!groupedByCategory[itemCategory]) {
                  groupedByCategory[itemCategory] = [];
                }

                groupedByCategory[itemCategory].push(item);
              });

              //Flatten the groupedByCategory to an array
              items = [];
              angular.forEach(groupedByCategory, function(groupItems) {
                angular.forEach(groupItems, function(item) {
                  items.push(item);
                });
              });
            }

            if (_opt.renderHeaderFunction && items.length > 0) {
              ul.append(_opt.renderHeaderFunction());
            }

            if (element.hasClass('nullable') && ngModelCtrl.$modelValue && element.val() === '') {
              _this._renderItemData(ul, {label: 'Not Set', value: null});
            }

            var currentCategory = '';
            if (items.length > 0) {
              $.each(items, function(index, item) {
                //If this box supports categories and it has changed, write the header.
                if (_opt.categoryField && $parse(_opt.categoryField)(item) != currentCategory) {
                  ul.append('<li class="ui-autocomplete-category ui-autocomplete-category-header">' + $parse(_opt.categoryField)(item) + '</li>');
                  currentCategory = $parse(_opt.categoryField)(item);
                }

                _this._renderItemData(ul, extractLabelValue(item));
              });
            } else {
              ul.append('<li class="ui-autocomplete-category"><strong>No Results Found</strong></li>');
            }

            if (_opt.moreFunction) {
              ul.append($compile('<li class="ui-autocomplete-category ui-autocomplete-category-footer" ng-click="moreLinkClicked()"><a>More</a></li>')(scope));
            }
          },
          _renderItem: function(ul, item) {
            return $('<li>').html(_opt.renderLineFunction(item)).appendTo(ul);
          },
          _resizeMenu: function() {
            // make the minimum width of the autocomplete popout menu be no
            // less than the width of the element it is attached to
            $(this.menu.element).css('min-width', $(element).css('width'));

            // override the jQuery UI automatic width setting with a value
            // that'll let the popout menu flow to the full width of it's
            // contents, by default this would be restricted to the width
            // of the input element it's attached to
            this.menu.element.outerWidth('revert');
          }
        });

        //The autocomplete will be bound on the first time focus of the element.
        if ($(element).hasClass('ui-autocomplete-input') === false) {
          $(element).autocomplete({
            source: function(req, res) {  //Callback for finding matches
              scope.$acInput = req.term;
              var items = $parse(attrs.autocompleteItems)(scope);

              if (typeof items.then == 'function') {//If the then is a function then this request is a promise
                // Give an indicator to the user that the search is pending
                showLoader();

                items.then(function(deferedItems) {
                  hideLoader();
                  if (deferedItems.length === 0) {
                    res(['_EMPTYRESULT_']);
                  } else {
                    res(deferedItems);
                  }
                }, function() {
                  hideLoader();
                });
              } else if (items.length === 0) {
                // Passing an empy array will result in the menu not being rendered.
                // Since we want to show the more link or other info, pass a placeholder result
                res(['_EMPTYRESULT_']);
              } else {
                res($filter('filter')(items, _opt.matchFunction));
              }
            },

            minLength: _opt.minLength,
            delay: _opt.callbackDelay,
            autoFocus: false,
            select: function(event, ui) {//Callback once option is selected
              if (attrs.ngModel) {
                $parse(attrs.ngModel).assign(scope, ui.item.value === null ? null : $parse(_opt.valueField)(ui.item.value));
              }

              if (attrs.autocompleteLabel) {
                $parse(attrs.autocompleteLabel).assign(scope, (ui.item.value === null) ? '' : ui.item.label);
              }

              if (attrs.autocompleteSelect) {
                scope.$acValue = ui.item.value;
                scope.$acLabel = ui.item.label;

                $timeout(function() {
                  scope.$eval(attrs.autocompleteSelect);
                }, 100);
              }

              //And finally blur out.
              $timeout(function() {
                $(element).blur();
              });

              ui.item.value = ui.item.label;
            },

            //When an item is focused, return false to prevent the input from updating
            focus: function() {
              return false;
            }
          }).mouseup(function(e) {
            e.preventDefault();
          }).on('blur.formatter', function() {
            $timeout(function() {
              render();
            });
          });
        }

        //Trigger the autocomplete to open.
        $timeout(function() {
          if (element.hasClass('ui-autocomplete-input')) {
            if (!element.attr('autocomplete-keepvalue')) {
              element.val('');
            }
            $(element).autocomplete('search', '');
          }
        }, 10);
      });
    }
  };
}]);
